import { useEffect, useRef } from "react";

const LoadTrigger = ({ onLoadMore, hasMore, isLoading }) => {
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!hasMore || isLoading) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onLoadMore();
        }
      },
      {
        root: null,
        rootMargin: "180px", // prefetch before actual end
        threshold: 0,
      },
    );

    if (triggerRef.current) {
      observer.observe(triggerRef.current);
    }
    return () => observer.disconnect();
  }, [onLoadMore, hasMore, isLoading]);

  return <div ref={triggerRef} style={{ height: "1rem" }} />;
};

export default LoadTrigger;
